import type { CodeLang, Env, RequestSpec } from '@/types';
import { buildUrl } from '@/api/client';
import { generateCurl } from './curl';
import { generateJsFetch } from './js-fetch';
import { generateNodeAxios } from './node-axios';
import { generatePython } from './python';
import { generatePhp } from './php';
import { generateGo } from './go';

export const CODE_LANGS: { id: CodeLang; label: string }[] = [
  { id: 'curl', label: 'cURL' },
  { id: 'js', label: 'JavaScript' },
  { id: 'node', label: 'Node.js' },
  { id: 'python', label: 'Python' },
  { id: 'php', label: 'PHP' },
  { id: 'go', label: 'Go' },
];

export function generateCode(
  lang: CodeLang,
  env: Env,
  spec: RequestSpec,
  hasAuth: boolean,
  apiBaseOverride?: string
): string {
  const url = buildUrl(env, spec, apiBaseOverride);
  switch (lang) {
    case 'curl':
      return generateCurl(url, spec, hasAuth);
    case 'js':
      return generateJsFetch(url, spec, hasAuth);
    case 'node':
      return generateNodeAxios(url, spec, hasAuth);
    case 'python':
      return generatePython(url, spec, hasAuth);
    case 'php':
      return generatePhp(url, spec, hasAuth);
    case 'go':
      return generateGo(url, spec, hasAuth);
  }
}
